import { PropsWithChildren } from 'react'

import {
  Text,
  GreyGrey80,
  Primary13Regular,
  Grid,
  GridItem
} from '@sequencehq/core-components'

export const SummaryGrid = ({ children }: PropsWithChildren) => (
  <Grid gridTemplateColumns="88px 1fr" rowGap="2px" columnGap="16px">
    {children}
  </Grid>
)

export const SummaryGridItem = ({
  name,
  value,
  'data-testid': dataTestId
}: {
  name: string
  value: string
  'data-testid'?: string
}) => (
  <>
    <GridItem>
      <Text {...Primary13Regular} color={GreyGrey80}>
        {name}:
      </Text>
    </GridItem>
    <GridItem>
      <Text {...Primary13Regular} color={GreyGrey80} data-testid={dataTestId}>
        {value}
      </Text>
    </GridItem>
  </>
)
